import { Box, Image, Text, Timer } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import { memo } from 'react';
import { CashbackTimerProps } from './CashbackTimer.types';
import { formatDate, SHORT_TIME } from '@bonanza-social/toolkit/utils';

function CashbackTimer({
  isActive,
  promotionEndDate,
  onCountDownComplete,
}: CashbackTimerProps) {
  const [t] = useTranslation('cashback');

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="space-100"
      backgroundColor="secondaryBackground"
      paddingHorizontal="space-200"
      paddingVertical="space-100"
      borderRadius="radius-300"
      alignSelf="flex-start"
    >
      <Image name="common.DarkClock" width="space-500" height="space-500" />
      <Box flexDirection="row" gap="space-050">
        {isActive ? (
          <>
            <Text
              variant="caption"
              color="darkSurfacePrimary"
              locNS="cashback"
              locKey="cashbackEndsIn"
            />
            <Timer
              variant="caption"
              color="darkSurfacePrimary"
              time={promotionEndDate}
              onCountDownComplete={onCountDownComplete}
            />
          </>
        ) : (
          <Text variant="caption" color="darkSurfacePrimary">
            {t('cashbackEndedOn', {
              date: formatDate(promotionEndDate),
              time: formatDate(promotionEndDate, SHORT_TIME),
              interpolation: { escapeValue: false },
            })}
          </Text>
        )}
      </Box>
    </Box>
  );
}

export default memo(CashbackTimer);
